import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { SharedCompsService } from 'avn/shared/shared-comps.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.html',
  styleUrls: ['./snackbar.scss']
})
export class SnackbarComponent implements OnInit {
  constructor(
    private sharedService: SharedCompsService,
    private router: Router
  ) {}

  readonly showSnack = signal(false);
  readonly message = signal('');
  sendClosedEvent = false;

  readonly buttonText = signal('Close');
  routerLink: any;

  timerSubscription: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.sharedService.snackBar.subscribe((data) => {
      this.showSnack.set(false);
      if (!data.message) return;
      if (this.timerSubscription) {
        clearTimeout(this.timerSubscription);
      }
      this.sendClosedEvent = data.sendBack;
      this.message.set(data.message);
      this.buttonText.set(data.buttonText || 'Close');
      this.showSnack.set(true);
      if (data.duration) {
        this.startTimer(data.duration);
      }
      if (data?.routerLink) {
        this.routerLink = data?.routerLink;
      }
    });
  }

  startTimer(timer: number) {
    this.timerSubscription = setTimeout(() => {
      this.showSnack.set(false);
    }, timer * 1000);
  }

  closeBtn() {
    this.showSnack.set(false);
    if (!this.sendClosedEvent) return;
    this.sharedService.snackBarClose.next(true);
    if (this?.routerLink) {
      this.router.navigate([this?.routerLink]);
    }
  }
}
